import { IconProps } from "./HomeIcon";

const BellIcon = ({ color = "#808080" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M5.33398 25.3307V22.6641H8.00065V13.3307C8.00065 11.4863 8.55621 9.8474 9.66732 8.41406C10.7784 6.98073 12.2229 6.04184 14.0007 5.5974V4.66406C14.0007 4.10851 14.1951 3.63628 14.584 3.2474C14.9729 2.85851 15.4451 2.66406 16.0007 2.66406C16.5562 2.66406 17.0284 2.85851 17.4173 3.2474C17.8062 3.63628 18.0007 4.10851 18.0007 4.66406V5.5974C19.7784 6.04184 21.2229 6.98073 22.334 8.41406C23.4451 9.8474 24.0007 11.4863 24.0007 13.3307V22.6641H26.6673V25.3307H5.33398ZM16.0007 29.3307C15.2673 29.3307 14.6395 29.0696 14.1173 28.5474C13.5951 28.0252 13.334 27.3974 13.334 26.6641H18.6673C18.6673 27.3974 18.4062 28.0252 17.884 28.5474C17.3618 29.0696 16.734 29.3307 16.0007 29.3307ZM10.6673 22.6641H21.334V13.3307C21.334 11.8641 20.8118 10.6085 19.7673 9.56406C18.7229 8.51962 17.4673 7.9974 16.0007 7.9974C14.534 7.9974 13.2784 8.51962 12.234 9.56406C11.1895 10.6085 10.6673 11.8641 10.6673 13.3307V22.6641Z"
        fill={color}
      />
    </svg>
  );
};

export default BellIcon;
